import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import BusinessDataForm, {
  BusinessDataFormContext,
  IBusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  defaultEditMenuCancelButton,
  defaultEditMenuSaveButton,
  IEditMenuAction,
  IFormData,
  removeIdsFromNewAssociations,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { BisattningsSettingsQuery } from '../../Queries/_QueryTypes/BisattningsSettingsQuery';
import {
  BisattningQuery as IBisattningQuery,
  BisattningQuery_node_TEDBOBisattning as IBisattningNode,
  BisattningQueryVariables as IBisattningVariables,
} from '../../ObjektVyer/AktuellaAvlidna/Queries/_QueryTypes/BisattningQuery';
import BisattningQuery from '../../ObjektVyer/AktuellaAvlidna/Queries/BisattningQuery.gql';
import { useMutation, useQuery } from '@apollo/client';
import AddMutation from '../../Mutation/BisattningAddMutation.gql';
import UpdateMutation from '../../Mutation/BisattningUpdateMutation.gql';
import {
  BisattningAddMutation as IAddMutation,
  BisattningAddMutationVariables as IAddMutationVariables,
} from '../../Mutation/_QueryTypes/BisattningAddMutation';
import {
  TEDBOBisattningshandelseTypEnum,
  TEDInputBOBisattningAddValues,
  TEDInputBOBisattningUpdateValues,
  TEDOPOrgPersLokTypEnum,
} from '../../../../../globalQueryTypes';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { useCollectionMutation } from '../../../../../Components/QueryComponents/CollectionMutation/useCollectionMutation';
import {
  BisattningUpdateMutation as IUpdateMutation,
  BisattningUpdateMutationVariables as IUpdateMutationVariables,
} from '../../Mutation/_QueryTypes/BisattningUpdateMutation';
import { IBusinessCollectionProps } from '../../../../../Types/ObjektVy';
import {
  MeQuery,
  MeQueryVariables,
} from '../../../Bokning/Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../../../Bokning/Rutiner/Kalender/Queries/MeQuery/MeQuery.gql';
import { LoginStateContext } from '../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import EDOPAvlidenSearchButtons from '../../Components/EDOPAvlidenSearchButtons';
import { tryDateTimeToDateTimeString } from '../../../../../Utils/dateUtils';
import {
  BegravningsbyraQuery,
  BegravningsbyraQueryVariables,
} from '../../Queries/_QueryTypes/BegravningsbyraQuery';
import begravningsbyraQuery from '../../Queries/BegravningsbyraQuery.gql';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import EDDialog from '../../../../../BaseComponents/Dialog/EDDialog';
import { useIsSmallScreen } from '../../../../../Hooks/useFullscreenView';
import QrCodeHandler from './QrCodeHandler';
import { PlaceringGrid } from '../PlaceringGrid';
import {
  BisattningsRumDelPlacering,
  BisattningsRumDelPlaceringVariables,
  BisattningsRumDelPlacering_db_BOBisattningsrum_All__Associations_Del_All,
} from '../../Queries/_QueryTypes/BisattningsRumDelPlacering';
import bisattningsRumDelPlaceringQuery from '../../Queries/BisattningsRumDelPlacering.gql';
import EDStandardSelect from '../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';
import EDDivider from '../../../../../BaseComponents/Divider/EDDivider';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface NyPlaceringProps extends IBusinessCollectionProps {
  bisattningSettings: BisattningsSettingsQuery | undefined;
  open: boolean;
  lokalInfo: {
    index: number | undefined;
    id: string;
  };
  setOpen: (open: boolean) => void;
}

const bisattningModel: IClientBusinessModel =
  clientAvenyModel.BO.BusinessModels.BOBisattning;

const NyPlacering: React.FC<NyPlaceringProps> = props => {
  const {
    nodeData,
    loading: nodeLoading,
    refetch: nodeRefetch,
  } = useSelectedDetailQuery<
    IBisattningQuery,
    IBisattningNode,
    IBisattningVariables
  >(BisattningQuery, props.id);

  const [persNr, setPersNr] = useState<string>('');
  const [bisattningID, setBisattningID] = useState<string | undefined>(
    undefined
  );
  const [bisattningVersion, setBisattningVersion] = useState<
    number | undefined
  >(undefined);
  const [avlidenID, setAvlidenID] = useState<string | undefined>(undefined);
  const [newAvlidenSearch, setNewAvlidenSearch] = useState<boolean>(false);
  const [senastBisattningHandelseTyp, setSenastBisattningHandelseTyp] =
    useState<TEDBOBisattningshandelseTypEnum | undefined>(undefined);
  const [QRText, setQRText] = useState('');
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const loginStateContext = useContext(LoginStateContext);
  const isSmallScreen = useIsSmallScreen();
  const [placeringText, setPlacering] = useState<string | undefined | null>('');
  const [room, setRoom] = useState<number | undefined>(undefined);

  const [placeringInfo, setPlaceringInfo] = useState<{
    rumBen: string | undefined;
    delBen: string | undefined;
    placeringID: string | undefined;
    placeringBen: string | undefined;
  }>({
    rumBen: undefined,
    delBen: undefined,
    placeringID: undefined,
    placeringBen: undefined,
  });
  const [previousPlaceringInfo, setPreviousPlaceringInfo] =
    useState<typeof placeringInfo>(placeringInfo);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [showDialog3, setShowDialog3] = useState<boolean>(false);
  const [roomTyp, setRoomTyp] = useState<string>('');
  const [personTyp, setPersonTyp] = useState<string>('');
  const [disableSave, setDisableSave] = useState<boolean>(false);

  const formContextRef =
    useRef<IBusinessDataFormContext<IBisattningNode> | null>(null);

  const [gridSizes, setGridSizes] = useState<
    { rows: number; columns: number }[]
  >([]);
  const { data: bisattningRum } = useQuery<
    BisattningsRumDelPlacering,
    BisattningsRumDelPlaceringVariables
  >(bisattningsRumDelPlaceringQuery, {
    variables: {
      dbname: activeDatabase ?? 'noDBYet',
      lokalID: props.lokalInfo.index?.toString() || '-1',
      typ: [{ value: 'K' }, { value: 'U' }],
    },
    fetchPolicy: 'network-only',
  });

  type Room = {
    header: string;
    value: number;
    delar: BisattningsRumDelPlacering_db_BOBisattningsrum_All__Associations_Del_All[];
    id: string;
    typ: string;
  };

  const [rooms, setRooms] = useState<Room[]>([]);

  const allRooms = useMemo(() => {
    if (bisattningRum?.db?.BOBisattningsrum_All) {
      return bisattningRum.db.BOBisattningsrum_All.map((rum, index) => ({
        header: rum.BENAMNING,
        value: index,
        delar: rum._Associations?.Del_All || [],
        id: rum.id,
        typ: rum.TYP,
      }));
    }
    return [];
  }, [bisattningRum?.db?.BOBisattningsrum_All]);

  const kistRooms = useMemo(
    () =>
      allRooms
        .filter(room => ['K', 'U'].includes(room.typ))
        .map((room, index) => ({
          ...room,
          value: index,
        })),
    [allRooms]
  );

  const urnRooms = useMemo(
    () =>
      allRooms
        .filter(room => room.typ === 'U')
        .map((room, index) => ({
          ...room,
          value: index,
        })),
    [allRooms]
  );

  if (rooms.length === 0 && allRooms.length > 0) {
    setRooms(allRooms);
  }
  const handleRumChange = (selected: number) => {
    setDisableSave(false);
    setRoom(selected);
    let roomTyp = rooms?.[selected]?.typ || '';

    if (roomTyp !== personTyp && personTyp !== 'T') {
      setShowDialog(true);
      setRoomTyp(roomTyp);
    } else {
      setRoomTyp(roomTyp);
    }

    const selectedRoom = rooms[selected];
    setPlaceringInfo({
      rumBen: selectedRoom?.header || '',
      delBen: undefined,
      placeringID: undefined,
      placeringBen: undefined,
    });
  };

  useEffect(() => {
    if (room !== undefined) {
      const selectedRoom = rooms[room];
      if (selectedRoom?.delar.length) {
        const sizes = selectedRoom.delar.map(del => ({
          rows: del.RADER || 0,
          columns: del.KOLUMNER || 0,
        }));
        setGridSizes(sizes);
      } else {
        setGridSizes([]);
      }
    }
  }, [room, rooms]);

  useEffect(() => {
    const numericPersNr = persNr.replace(/\D/g, '');
    if (!avlidenID && numericPersNr.length === 12) {
      setShowDialog3(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newAvlidenSearch]);

  const [addMutation, addStatus] = useMutation<
    IAddMutation,
    IAddMutationVariables
  >(AddMutation, {
    refetchQueries: ['collection'],
  });

  const [updateMutation, { loading, error }] = useCollectionMutation<
    IUpdateMutation,
    IUpdateMutationVariables
  >(UpdateMutation);

  const addFunction = useCallback(
    (values: IFormData) => {
      if (values?._Associations) {
        let changedBisattningTyp = null;
        if (values._Associations?.Handelse_Update_Values) {
          changedBisattningTyp =
            values._Associations?.Handelse_Update_Values?.[0]?.TYP;
          delete values._Associations?.Handelse_Update_Values;
        }

        /** ======== Bisättningshändelse ======== */

        let placeringEjMall = null;
        let placeringID = null;
        if (values?._Associations?.SenasteHandelse_Values) {
          placeringEjMall =
            values._Associations.SenasteHandelse_Values.PLACERING_EJ_MALL ||
            null;
          placeringID =
            values._Associations.SenasteHandelse_Values.PLACERING_ID || '';
          delete values?._Associations?.SenasteHandelse_Values;
        }

        /** ======== Ta bort onödig data ======== */
        if (values?._Associations?.Avlidna_Values)
          delete values?._Associations?.Avlidna_Values;
        if (values?._Associations?.Begravningsbyra_Ref)
          delete values?._Associations?.Begravningsbyra_Ref;

        const handelseAddValues =
          values._Associations.Handelse_Add_Values || [];

        const newEntry = {
          _typ: TEDBOBisattningshandelseTypEnum.BISATTNINGSHANDELSEUT,
          DATUM: tryDateTimeToDateTimeString(new Date()),
          TRANSPORTOR: me_data?.me?.[0]?.userIsBegrByra
            ? begravningsbyra_data?.node?.__typename === 'TEDOPOrgPersLok'
              ? begravningsbyra_data?.node?.Namn
              : ''
            : loginStateContext.name,
          //TODO fixa fältet nedan
          BISATTNINGSTYP_ID: changedBisattningTyp === 'K' ? 1 : 2,
          _Associations: {
            Anvandare_Ref: me_data?.me?.[0]?.userId,
          },
        };
        handelseAddValues.push(newEntry);
        handelseAddValues.push({
          ...newEntry,
          _typ: TEDBOBisattningshandelseTypEnum.BISATTNINGSHANDELSEIN,
          PLACERING_EJ_MALL: placeringEjMall,
          _Associations: {
            Anvandare_Ref: me_data?.me?.[0]?.userId,
            Lokal_Ref: props.lokalInfo.id,
            Placering_Ref: placeringID,
          },
        });
        values._Associations.Handelse_Add_Values = handelseAddValues;

        if (bisattningID) {
          //TODO: måste vara inlämnad så borde inte behöva en addMutation
          return updateMutation({
            variables: {
              db: activeDatabase || '',
              values: {
                id: bisattningID,
                _version: bisattningVersion,
                ...values,
              } as TEDInputBOBisattningUpdateValues,
            },
            refetchQueries: ['rtnWebBisattningsjournal'],
          });
        } else {
          if (values?._Associations?.Avlidna_Values) {
            if (avlidenID) {
              delete values._Associations.Avlidna_Values;
              values._Associations.Avlidna_Ref = avlidenID;
            }
          }
          return addMutation({
            variables: {
              db: activeDatabase || '',
              values: {
                ...values,
              } as TEDInputBOBisattningAddValues,
            },
            refetchQueries: ['rtnWebBisattningsjournal'],
          });
        }
      }
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: {} as TEDInputBOBisattningAddValues,
        },
        refetchQueries: ['rtnWebBisattningsjournal'],
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      activeDatabase,
      addMutation,
      avlidenID,
      bisattningID,
      bisattningVersion,
      senastBisattningHandelseTyp,
      updateMutation,
      formContextRef,
    ]
  );

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values ?? {});
      return updateMutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: nodeData?.id ?? '',
            _version: nodeData?._version ?? 1,
            ...newValues,
          },
        },
      });
    },
    [updateMutation, activeDatabase, nodeData?.id, nodeData?._version]
  );

  const activeDatabaseOptions = useMemo(
    () => ({
      variables: {
        dbname: activeDatabase ?? 'noDBYet',
      },
      skip: !activeDatabase,
    }),
    [activeDatabase]
  );
  const { data: me_data } = useQuery<MeQuery, MeQueryVariables>(
    meQuery,
    activeDatabaseOptions
  );
  const { data: begravningsbyra_data } = useQuery<
    BegravningsbyraQuery,
    BegravningsbyraQueryVariables
  >(begravningsbyraQuery, {
    variables: { id: me_data?.me?.[0]?.userOPID ?? 'NoIDYet' },
    skip: !me_data?.me?.[0]?.userOPID,
  });

  function addQRValues(
    str: string,
    formContext: IBusinessDataFormContext<any, unknown>
  ) {
    const values = str.split('#');
    formContext?.update([
      {
        operation: 'Values',
        associationName: 'Avlidna',
        values: {},
      },
      {
        operation: 'Values',
        associationName: 'Person',
        values: {
          _typ: TEDOPOrgPersLokTypEnum.PERSON,
          PERS_NR: values[0],
          FORNAMN: values[2],
          EFTERNAMN: values[1],
          _Associations: { Adress_Values: {} },
        },
      },
    ]);
    setPersNr(
      values[0].length === 12
        ? values[0].slice(0, 8) + '-' + values[0].slice(8)
        : values[0]
    );
  }

  function clearStates() {
    setPersNr('');
    setAvlidenID('');
    setSenastBisattningHandelseTyp(undefined);
    setQRText('');
    setPlacering('');
    setPlaceringInfo({
      delBen: undefined,
      placeringBen: undefined,
      placeringID: undefined,
      rumBen: undefined,
    });
    setPreviousPlaceringInfo({
      delBen: undefined,
      placeringBen: undefined,
      placeringID: undefined,
      rumBen: undefined,
    });
    setRoomTyp('');
    setRoom(undefined);
    setGridSizes([]);
    setPersonTyp('');
    setDisableSave(false);
    setNewAvlidenSearch(false);
  }

  const saveButton: IEditMenuAction = {
    label: 'Spara',
    id: 'Knapp_Spara',
    onClick: ({ businessDataFormContext }) => {
      businessDataFormContext?.saveForm(undefined, () => {
        clearStates();
        businessDataFormContext?.formStateDispatch({
          type: 'RESET',
        });
        businessDataFormContext?.formStateDispatch({
          type: 'ENTER_EDITMODE',
        });
        props.setOpen(false);
      });
    },
    isDisabled: () => {
      if (
        placeringInfo === previousPlaceringInfo ||
        (!!rooms[room ?? -1]?.delar.length && !placeringInfo.placeringID)
      ) {
        return true;
      }
      if (disableSave) return true;
      if (
        (!!rooms[room ?? -1]?.delar.length && !placeringInfo.placeringID) ||
        placeringInfo === previousPlaceringInfo
      )
        return true;
      return false;
    },
    flat: true,
    icon: defaultEditMenuSaveButton.icon,
    hideIconIfNotFloating: defaultEditMenuCancelButton.hideIconIfNotFloating,
  };

  const cancelButton: IEditMenuAction = {
    label: 'Avbryt',
    id: 'Knapp_Avbryt',
    onClick: ({ businessDataFormContext }) => {
      clearStates();
      businessDataFormContext?.formStateDispatch({ type: 'CANCEL' });
      businessDataFormContext?.formStateDispatch({
        type: 'ENTER_EDITMODE',
      });
      props.setOpen(false);
    },
    flat: true,
    icon: defaultEditMenuCancelButton.icon,
    hideIconIfNotFloating: defaultEditMenuCancelButton.hideIconIfNotFloating,
  };

  const clearButton: IEditMenuAction = {
    label: 'Rensa',
    id: 'Knapp_Rensa',
    onClick: ({ businessDataFormContext }) => {
      clearStates();
      businessDataFormContext?.formStateDispatch({ type: 'RESET' });
      businessDataFormContext?.formStateDispatch({
        type: 'ENTER_EDITMODE',
      });

      businessDataFormContext?.update([
        {
          operation: 'Values',
          associationName: 'Avlidna',
          values: {},
        },
        {
          operation: 'Values',
          associationName: 'SenasteHandelse',
          values: {},
        },
      ]);
    },
    isDisabled: ({ businessDataFormContext }) => {
      let disabledReason = null;
      if (!businessDataFormContext?.formState?.formHasChanged && !QRText) {
        disabledReason = 'Rensa';
      }
      if (disabledReason) {
        return disabledReason;
      }
      return false;
    },
    flat: true,
    icon: 'clear',
    hideIconIfNotFloating: true,
  };

  return me_data?.me?.[0]?.userOPID ? (
    <BusinessDataForm<IBisattningNode>
      isNew={true}
      newFormContext
      data={nodeData}
      model={bisattningModel}
      updateMutation={updateFunction}
      addMutation={addFunction}
      refetchData={nodeRefetch}
      dataLoading={nodeLoading}
      isEditing
      mutationError={error || addStatus.error}
      mutationLoading={loading || addStatus.loading}
      editMenuActions={[cancelButton, clearButton, saveButton]}
    >
      <BusinessDataFormContext.Consumer>
        {formContext => {
          formContextRef.current = formContext;
          {
            formContext?.mutationLoading && <EDAvenyProgress />;
          }
          return (
            <ObjektVy nodeLoading={nodeLoading}>
              <ObjektVySida
                caption={'Ny placering'}
                sidNr={1}
                collectionName={bisattningModel.CollectionName}
                noPaddingMargin
              >
                <ObjektVyKort caption="LÄS IN QR-KOD">
                  <QrCodeHandler
                    QRText={QRText}
                    setQRText={setQRText}
                    addQRValues={addQRValues}
                    formContext={formContext}
                  />
                </ObjektVyKort>
                <EDBox
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: isSmallScreen ? 'column' : 'row',
                  }}
                >
                  <EDBox
                    sx={{
                      width: !isSmallScreen ? '33%' : '100%',
                      marginBottom: isSmallScreen ? 1 : undefined,
                    }}
                  >
                    <ObjektVyKort caption="Avliden">
                      <EDBox sx={{ display: 'flex', gap: 2 }}>
                        <EDBox sx={{ flex: 1 }}>
                          <EDOPAvlidenSearchButtons
                            formContext={formContext}
                            persNr={persNr}
                            setPersNr={setPersNr}
                            fetchPacemaker={false}
                            // skicka med rum
                            onCompleteNyPlacering={(
                              avlID,
                              bisID,
                              bisVer,
                              bisTyp,
                              senBisTyp,
                              placeringText,
                              placeringInfo,
                              roomID
                            ) => {
                              setAvlidenID(avlID);
                              setNewAvlidenSearch(true);
                              setBisattningID(bisID);
                              setBisattningVersion(bisVer);
                              setSenastBisattningHandelseTyp(senBisTyp);
                              setPlacering(placeringText);
                              setPlaceringInfo(placeringInfo);
                              setPreviousPlaceringInfo(placeringInfo);
                              let bTyp =
                                bisTyp === 'Kista'
                                  ? 'K'
                                  : bisTyp === 'Urna / Aska'
                                  ? 'U'
                                  : bisTyp === 'Stoft'
                                  ? 'S'
                                  : '-';
                              if (bTyp === 'U') {
                                setRooms(urnRooms);
                                setRoom(
                                  placeringText && !placeringInfo?.placeringID
                                    ? 0
                                    : urnRooms.find(r => r.id === roomID)?.value
                                );
                                setRoomTyp(
                                  urnRooms.find(r => r.id === roomID)?.typ || ''
                                );
                              } else if (bTyp === 'K') {
                                setRooms(kistRooms);
                                setRoom(
                                  placeringText && !placeringInfo?.placeringID
                                    ? 0
                                    : kistRooms.find(r => r.id === roomID)
                                        ?.value
                                );
                                setRoomTyp(
                                  kistRooms.find(r => r.id === roomID)?.typ ||
                                    ''
                                );
                              } else {
                                setRooms(allRooms);
                                setRoom(
                                  placeringText && !placeringInfo?.placeringID
                                    ? 0
                                    : allRooms.find(r => r.id === roomID)?.value
                                );
                                setRoomTyp(
                                  allRooms.find(r => r.id === roomID)?.typ || ''
                                );
                              }
                              setPersonTyp(bTyp);
                              formContext?.update([
                                {
                                  operation: 'Update_Values',
                                  associationName: 'Handelse',
                                  id: 'AddTyp',
                                  values: {
                                    TYP: bTyp,
                                  },
                                },
                              ]);
                            }}
                          />
                        </EDBox>
                      </EDBox>
                      <Attribut
                        name="Avlidna.Person.FORNAMN"
                        mode="edit"
                        disabled={true}
                      />
                      <Attribut
                        name="Avlidna.Person.EFTERNAMN"
                        mode="edit"
                        disabled={true}
                      />
                      <EDBox
                        marginTop={'2%'}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                        }}
                      >
                        <EDTypography sx={{ whiteSpace: 'nowrap' }}>
                          <strong>Placering:</strong> {placeringText ?? ''}
                        </EDTypography>
                      </EDBox>
                    </ObjektVyKort>
                  </EDBox>
                  <EDBox
                    sx={{
                      width: !isSmallScreen ? '66%' : '100%',
                      marginBottom: isSmallScreen ? 1 : undefined,
                    }}
                  >
                    <ObjektVyKort caption="Placering">
                      <EDStandardSelect<number | ''>
                        label="Välj rum"
                        onChange={e => {
                          if (typeof e === 'number') {
                            handleRumChange(e);
                            formContext?.update([
                              {
                                operation: 'Update_Values',
                                associationName: 'Handelse',
                                id: 'AddTyp',
                                values: {
                                  TYP: roomTyp,
                                },
                              },
                            ]);
                          }
                        }}
                        value={room ?? ''}
                        items={rooms}
                        disabled={!avlidenID}
                        testId="ValjRum"
                      />
                      <EDDivider marginBottom={3} />
                      <PlaceringGrid
                        formContext={formContext}
                        directUpdate={true}
                        gridSizes={gridSizes}
                        rooms={rooms}
                        room={room}
                        placeringInfo={placeringInfo}
                        setPlaceringInfo={setPlaceringInfo}
                      />
                    </ObjektVyKort>
                  </EDBox>
                </EDBox>

                {!!senastBisattningHandelseTyp &&
                  senastBisattningHandelseTyp !==
                    TEDBOBisattningshandelseTypEnum.BISATTNINGSHANDELSEIN && (
                    <EDDialog
                      open
                      footerActions={[
                        {
                          label: 'Ok',
                          onClick: () => {
                            clearStates();
                            formContext?.formStateDispatch({ type: 'RESET' });
                            formContext?.formStateDispatch({
                              type: 'ENTER_EDITMODE',
                            });
                          },
                        },
                      ]}
                      onClose={() => {
                        clearStates();
                        formContext?.formStateDispatch({ type: 'RESET' });
                        formContext?.formStateDispatch({
                          type: 'ENTER_EDITMODE',
                        });
                      }}
                    >
                      <EDTypography testId="BisattningInfoMessage">
                        {persNr}
                        <br />
                        Den avlidne har inte lämnats in i lokalen.
                      </EDTypography>
                    </EDDialog>
                  )}
                {personTyp === 'S' && (
                  <EDDialog
                    open
                    footerActions={[
                      {
                        label: 'Ok',
                        onClick: () => {
                          clearStates();
                          formContext?.formStateDispatch({ type: 'RESET' });
                          formContext?.formStateDispatch({
                            type: 'ENTER_EDITMODE',
                          });
                        },
                      },
                    ]}
                    onClose={() => {
                      clearStates();
                      formContext?.formStateDispatch({ type: 'RESET' });
                      formContext?.formStateDispatch({
                        type: 'ENTER_EDITMODE',
                      });
                    }}
                  >
                    <EDTypography testId="BisattningInfoMessage">
                      {persNr}
                      <br />
                      Ny placering finns inte för stoft.
                    </EDTypography>
                  </EDDialog>
                )}
                {showDialog && (
                  <EDDialog
                    open
                    onClose={() => {
                      setShowDialog(false);
                      setDisableSave(true);
                    }}
                    footerActions={[
                      {
                        label: 'Ja',
                        onClick: () => {
                          setShowDialog(false);
                          setPersonTyp(roomTyp);
                          formContext?.update([
                            {
                              operation: 'Update_Values',
                              associationName: 'Handelse',
                              id: 'AddTyp',
                              values: {
                                TYP: roomTyp,
                              },
                            },
                          ]);
                          setDisableSave(false);
                        },
                      },
                      {
                        label: 'Nej',
                        onClick: () => {
                          setShowDialog(false);
                          setDisableSave(true);
                        },
                      },
                    ]}
                  >
                    <EDTypography testId="BisattningInfoMessage">
                      {persNr} Är inlämnad som{' '}
                      {personTyp === 'K'
                        ? 'kista'
                        : personTyp === 'U'
                        ? 'urna / aska'
                        : personTyp === 'T'
                        ? 'tom urna'
                        : '-'}
                      .<br />
                      Vill du ändra typen till{' '}
                      {roomTyp === 'K'
                        ? 'kista'
                        : roomTyp === 'U'
                        ? 'urna / aska'
                        : roomTyp === 'T'
                        ? 'tom urna'
                        : '-'}
                      ?
                    </EDTypography>
                  </EDDialog>
                )}
                {showDialog3 && (
                  <EDDialog
                    open
                    onClose={() => {
                      setShowDialog3(false);
                      clearStates();
                    }}
                    footerActions={[
                      {
                        label: 'OK',
                        onClick: () => {
                          setShowDialog3(false);
                          clearStates();
                        },
                      },
                    ]}
                  >
                    <EDTypography testId="BisattningInfoMessage">
                      {persNr}
                      <br />
                      {'Avliden finns ej i systemet och behöver lämnas in.'}
                    </EDTypography>
                  </EDDialog>
                )}
              </ObjektVySida>
            </ObjektVy>
          );
        }}
      </BusinessDataFormContext.Consumer>
    </BusinessDataForm>
  ) : null;
};

export default NyPlacering;
